export default __webpack_public_path__ + "static/media/004-son.efb07c21.png";